import * as pdfjsLib from "pdfjs-dist/build/pdf";
import api from "@/lib/api";

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

// Fetch a slip PDF endpoint and render page 1 to a JPEG Blob (siap kirim WA).
export async function slipPdfToJpeg(pdfUrl, { scale = 2, quality = 0.92 } = {}) {
  const r = await api.get(pdfUrl, { responseType: "blob" });
  const buf = await r.data.arrayBuffer();
  const doc = await pdfjsLib.getDocument({ data: buf }).promise;
  const page = await doc.getPage(1);
  const vp = page.getViewport({ scale });
  const canvas = document.createElement("canvas");
  canvas.width = vp.width; canvas.height = vp.height;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, canvas.width, canvas.height);
  await page.render({ canvasContext: ctx, viewport: vp }).promise;
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
  const dataUrl = canvas.toDataURL("image/jpeg", quality);
  try { doc.destroy(); } catch (_) { /* noop */ }
  return { blob, dataUrl };
}
